import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from '@core/auth/login.component';
import { UnauthorizedAccessComponent } from '@core/auth/UnauthorizedAccess.component';
import { AreasPageComponent } from './pages/areas/areas.component';
import { ThingsPageComponent } from '@pages/things/things.component';
import { ThingsDetailsPageComponent } from '@pages/things/details.component';
import { AuthGuard } from '@core/auth/auth-guard.service';
import {SearchPageComponent} from "@pages/search/search.component";
import {ResourcesPageComponent} from "@pages/resources/resources.component";

const routes: Routes = [
  {
    path: '',
    redirectTo: '/areas',
    canActivate: [AuthGuard],
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'unauthorizedAccess',
    component: UnauthorizedAccessComponent
  },
  {
    path: 'areas',
    component: AreasPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'areas/:areaId/things',
    component: ThingsPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'search',
    component: SearchPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'things/:thingId',
    component: ThingsDetailsPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'resources',
    component: ResourcesPageComponent,
    canActivate: [AuthGuard]
  }
]

@NgModule({
  imports: [ RouterModule.forRoot(routes, { useHash: true }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/app-routing.module.ts